import { BehaviorSubject } from 'rxjs';
import { IAssignee } from '../model/assignee.interface';

export abstract class AssigneesRepository {
    public ready: BehaviorSubject<boolean> = new BehaviorSubject(false);    
    public assignees: IAssignee[] = [];    
}
